export default __webpack_public_path__ + "static/media/claimGift.f3b70e29.png";